"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconSVG = _interopRequireDefault(require("../components/IconSVG"));
var _excluded = ["size", "title", "ariaHidden"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var pathSizesToPaths = {
  "16": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M1 8.444h3.491V2.022H1v6.422Zm3.991 1H.5a.5.5 0 0 1-.5-.5V1.521a.5.5 0 0 1 .5-.5h4.491a.5.5 0 0 1 .5.5v7.423a.5.5 0 0 1-.5.5Zm-2.353 3.232H15.5a.5.5 0 0 0 .5-.5V3.52a.5.5 0 0 0-.5-.5H6.15v1H15v7.657H3.138v-1.239h-1v1.74a.5.5 0 0 0 .5.5Zm6.53-6.537a.625.625 0 1 0 0-1.25.625.625 0 0 0 0 1.25Zm3.674 8.84H5.297v-1H8.46v-.752h1v.752h3.382v1ZM2.757 7.652a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Z"
  }),
  "24": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M1.125 12.877h5.724V2.683H1.125v10.194Zm6.287 1.125H.562A.563.563 0 0 1 0 13.439V2.121c0-.31.252-.563.563-.563h6.849c.31 0 .562.252.562.563v11.318c0 .31-.252.563-.563.563ZM3.824 18.93h19.614c.31 0 .562-.252.562-.563V5.166a.563.563 0 0 0-.562-.562H9.178v1.125h13.697v12.077H4.386v-2.687H3.261v3.25c0 .31.252.562.563.562Zm9.96-10.026a.844.844 0 1 0 0-1.687.844.844 0 0 0 0 1.687Zm5.6 13.537H7.877v-1.125h5.025V19.97h1.125v1.347h5.357v1.125ZM4.004 11.495a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
  }),
  "32": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M1.5 17.169h7.632V3.578H1.5v13.591Zm8.382 1.5H.75a.75.75 0 0 1-.75-.75V2.828a.75.75 0 0 1 .75-.75h9.132a.75.75 0 0 1 .75.75v15.091a.75.75 0 0 1-.75.75Zm-4.784 6.572H31.25a.75.75 0 0 0 .75-.75V6.888a.75.75 0 0 0-.75-.75H12.238v1.5H30.5v16.103H5.848v-3.583h-1.5v4.333c0 .414.336.75.75.75Zm13.28-13.368a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25Zm7.467 18.049H10.503v-1.5h6.699v-1.795h1.5v1.795h7.143v1.5ZM5.34 15.326a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
  }),
  "48": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M1.875 25.964H13.81V5.017H1.875v20.947Zm12.872 1.875H.937A.937.937 0 0 1 0 26.902V4.079c0-.517.42-.937.938-.937h13.81c.518 0 .937.42.937.937v22.823c0 .518-.42.937-.938.937Zm-7.234 9.94h39.55c.517 0 .937-.42.937-.937V10.22a.938.938 0 0 0-.938-.937h-28.75v1.875h27.813v24.746H8.45v-5.616H6.576v6.554c0 .517.42.937.937.937Zm20.083-20.788a1.5 1.5 0 1 0 0-3.001 1.5 1.5 0 0 0 0 3.001ZM38.89 44.858H15.687v-1.875h10.328v-2.912h1.875v2.912h10.999v1.875ZM7.879 23.301a1.139 1.139 0 1 0 0-2.278 1.139 1.139 0 0 0 0 2.277Z"
  }),
  "64": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M2.5 34.619h15.914V6.689H2.5v27.93Zm17.163 2.5H1.25A1.25 1.25 0 0 1 0 35.869V5.439c0-.69.559-1.25 1.25-1.25h18.413c.691 0 1.25.56 1.25 1.25v30.43a1.25 1.25 0 0 1-1.25 1.25Zm-9.645 13.253H62.75c.69 0 1.25-.56 1.25-1.25V13.627c0-.69-.56-1.25-1.25-1.25H24.415v2.5H61.5v32.995H11.268v-7.488h-2.5v8.738c0 .69.56 1.25 1.25 1.25Zm26.777-27.717a2.001 2.001 0 1 0 0-4.002 2.001 2.001 0 0 0 0 4.002Zm15.057 37.156H20.916v-2.5h13.77v-3.883h2.5v3.883h14.666v2.5ZM10.505 31.067a1.518 1.518 0 1 0 0-3.037 1.518 1.518 0 0 0 0 3.037Z"
  })
};
var pathSizesToViewBox = {
  "16": "0 0 16 16",
  "24": "0 0 24 24",
  "32": "0 0 32 32",
  "48": "0 0 48 48",
  "64": "0 0 64 64"
};
var sizesToPathSizes = {
  "16": "16",
  "24": "24",
  "32": "32",
  "48": "48",
  "64": "64"
};
var sizes = ['16', '24', '32', '48', '64'];
var IconComputerPhone = function IconComputerPhone(_ref) {
  var _ref$size = _ref.size,
    sizeProp = _ref$size === void 0 ? '32' : _ref$size,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Computer Phone' : _ref$title,
    _ref$ariaHidden = _ref.ariaHidden,
    ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var size = sizes.indexOf(sizeProp) !== -1 ? sizeProp : '32';
  return /*#__PURE__*/_react.default.createElement(_IconSVG.default, (0, _extends2.default)({
    width: size,
    height: size,
    viewBox: pathSizesToViewBox[sizesToPathSizes[size]],
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    role: "img",
    title: title,
    ariaHidden: ariaHidden
  }, props, {
    iconClass: "ComputerPhone"
  }), pathSizesToPaths[sizesToPathSizes[size]]);
};
IconComputerPhone.sizes = [16, 24, 32, 48, 64];
IconComputerPhone.propTypes = {
  /** Available sizes: 16, 24, 32, 48, 64. In most cases, the size will be a square (e.g., 32px X 32px), but height variances can occur. */
  size: _propTypes.default.oneOf(sizes),
  /** Similar to the 'alt' attribute on image tags, this is optional for custom tooltips and will default to the icon name if not overriden. */
  title: _propTypes.default.string,
  /** Hide icon from screen readers. */
  ariaHidden: _propTypes.default.bool,
  /** Optional custom class. */
  className: _propTypes.default.string
};
var _default = IconComputerPhone;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@lmig/design-system-icons-react/_cjs/coverage-options/ComputerPhone.js
// module id = 1987
// module chunks = 0